import { CanDeactivateFn } from '@angular/router';
import { AlphaJsonSchemaEditorComponent } from '../components/case-definition/alpha-json-schema-editor/alpha-json-schema-editor.component';
import { ConfigEditorComponent } from '../components/config-editor/config-editor.component';
import { PageEditorComponent } from '../components/pages/components/page-editor/page-editor.component';
import { PagesComponent } from '../components/pages/components/pages/pages.component';
import { StylesComponent } from '../components/styles-menu/components/layout/layout.component';

type editorComponents =
    | AlphaJsonSchemaEditorComponent
    | PageEditorComponent
    | PagesComponent
    | ConfigEditorComponent
    | StylesComponent;

export const isSavedGuard: CanDeactivateFn<editorComponents> = async (component: editorComponents) => {
    if (component && component.isEditorSaved) {
        if (await component?.isEditorSaved()) return true;
        else return false;
    }
    return true;
};
